// This file is auto-generated. Do not edit manually.

import { DiagnosticLevel } from './DiagnosticLevel';

export const scoringQuestionsByGroup: Record<string, string[]> = {
  'Etoile1': [
    'bainLargeurPorte90',
    'bainPrisesHautes',
    'chambreLargeurPorte90',
    'chambrePrisesBasses',
    'chambrePrisesHautes',
    'communAscenseurNorme',
    'communBoiteManoeuvre',
    'communHallEclairage90',
    'communHallEclairageAuto',
    'cuisineEspace',
    'cuisinePrisesCredence',
    'cuisineProfondeur',
    'cuisineSiphon',
    'dispositifHanteur90',
    'dispositifPrisesBasses',
    'dispositifPrisesHautes',
    'doucheCloisons',
    'doucheParois',
    'entreeLargeur',
    'generalLargeurEgal120',
    'generalLargeurPorte90',
    'generalPlacardAdapte',
    'generalPrisesBasses',
    'generalPrisesHautes',
    'lavaboHauteur',
    'statioProxi',
    'statioSousSol',
    'terrasseRampe',
    'wcCloison',
  ],
  'Etoile2': [
    'chambrePlacardAdapte',
    'communPorteFourreau',
    'dispositifManoeuvreSecours',
    'doucheItalienne',
    'doucheItalienneOk',
    'entreeAuto',
    'entreeEclairage',
    'generalLargeurSup120',
    'lavaboHauteurReglable',
    'statioDedie',
    'terrasseAcces',
    'terrasseFourreau',
    'terrasseRessaut',
    'wcSuspendu',
  ],
  'Etoile3': [
    'chemExtPortillonAuto',
    'chemExtPortillonTele',
    'communAscenseurHori',
    'communPorteAuto',
    'communPorteTele',
    'doucheCloisons',
    'statioSousSolMotorise',
    'statioSurface',
    'statioSurfaceMotorise',
  ],
  'Etoile3Obligatoire': [
    'communPorteAuto',
  ],
  'Senior': [
    'dispositifFourreauVolets',
    'dispositifVoletElec',
    'doucheBarreAppui',
    'doucheReceveurEncastre',
    'doucheSiege',
    'wcBarreAppui',
    'wcHauteur',
  ],
};

export const diagnosticLevelRequirements: Record<DiagnosticLevel, Record<string, number>> = {
  [DiagnosticLevel.Accessible]: { },
  [DiagnosticLevel.Senior]: { 'Senior': 5 },
  [DiagnosticLevel.OneEtoile]: { 'Etoile1': 18 },
  [DiagnosticLevel.TwoEtoiles]: { 'Etoile1': 18,  'Etoile2': 8 },
  [DiagnosticLevel.ThreeEtoiles]: { 'Etoile1': 18,  'Etoile2': 8,  'Etoile3': 3,  'Etoile3Obligatoire': 1 },
};
